import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import whobanner from "../img/contact.png";

import { Mail, Phone, MapPin } from 'lucide-react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import L from "leaflet";
import "leaflet/dist/leaflet.css";

/* Leaflet marker fix */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

/* ✅ AUTO-FIT INDIA + UK ON LOAD */
const FitWorldBounds = () => {
  const map = useMap();

  useEffect(() => {
    const bounds = L.latLngBounds(
      [17.4521, 78.3926],   // India
      [52.4082, -1.4956]   // UK
    );

    map.fitBounds(bounds, {
      padding: [50, 50],
      animate: true,
    });
  }, [map]);

  return null;
};

const Contact = () => {
  const mapRef = useRef(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    country_code: '+91',
    phoneno: '',
    location: '',
    purpose: '',
    message: '',
  });

  const [formMessage, setFormMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showModal, setShowModal] = useState(false);
const [modalData, setModalData] = useState({ type: "", message: "" });


  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000, once: true });
  }, []);

const handleChange = (e) => {
  const { name, value } = e.target;

  // ✅ Name: only alphabets & spaces
  if (name === "name") {
    if (!/^[A-Za-z\s]*$/.test(value)) return;
  }

  setFormData((prev) => ({ ...prev, [name]: value }));
};


  const isValidPhoneNumber = () => {
    try {
      const phone = parsePhoneNumberFromString(
        `${formData.country_code}${formData.phoneno}`
      );
      return phone?.isValid();
    } catch {
      return false;
    }
  };

  const openModal = (type, message) => {
  setModalData({ type, message });
  setShowModal(true);

  // scroll AFTER popup opens
  // setTimeout(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, 50);

  // auto close after 5 seconds
  setTimeout(() => {
    setShowModal(false);
  }, 5000);
};

const nameRegex = /^[A-Za-z\s]+$/;


const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  // ✅ phone validation
  if (!isValidPhoneNumber()) {
    openModal("error", "Please enter a valid phone number.");
    setIsSubmitting(false);
    return;
  }

  try {
    // ✅ Name validation
if (!nameRegex.test(formData.name)) {
  openModal("error", "Name should contain only alphabets.");
  setIsSubmitting(false);
  return;
}

    await axios.post(
      "https://api.securxperts.com:8000/forms/contact",
      formData,
      { headers: { "Content-Type": "application/json" } }
    );

    // ✅ SUCCESS POPUP
    openModal("success", "Contact Form Submitted Successfully.");

    // reset form
    setFormData({
      name: "",
      email: "",
      country_code: "+91",
      phoneno: "",
      location: "",
      purpose: "",
      message: "",
    });
  } catch (error) {
    // ❌ ERROR POPUP
    openModal("error", "Server error. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};

  

  return (
  <div className="min-h-screen bg-gray-50 font-sans relative z-0">
      <Navbar />

      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-cover bg-center"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
            <h1 className="text-4xl font-bold">Contact Us</h1>
            <div className="flex items-center gap-2">
              <Link to="/" className="hover:underline">Home</Link>
             <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Contact Us</span>
            </div>
          </div>
        </div>
      </header>

      <section className="py-20">
        <div className="max-w-6xl mx-auto bg-white shadow-xl rounded-xl flex flex-col lg:flex-row">

          {/* LEFT */}
          <div className="bg-[#1b1b1b] text-white p-10 lg:w-5/12 space-y-6">
            <h2 className="text-3xl font-bold">Contact Information</h2>

            <p className="flex items-center"><Phone className="mr-2" /> +91 79932 58679</p>
            <p className="flex items-center"><Mail className="mr-2" /> info@SecurXperts.com</p>
{/* ADDRESSES */}
<div className="space-y-6 text-sm leading-relaxed">
  <div className="flex items-start gap-3">
    <MapPin className="mt-1 text-blue-400" />
    <div>
      <p className="font-semibold">India Office:</p>
      <p>PR R One Towers, Plot No 59, Third Floor,</p>
      <p>Jayabheri Enclave-2, Near Radission Hotel,</p>
      <p>Gachibowli,</p>
      <p>Hyderabad, Telangana 500032</p>
    </div>
  </div>

  <div className="border-t border-white/20 pt-6 flex items-start gap-3">
    <MapPin className="mt-1 text-blue-400" />
    <div>
      <p className="font-semibold">UK Office:</p>
      <p>194 Gulson Road,</p>
      <p>Coventry, England, CV1 2JD</p>
      <p>United Kingdom</p>
    </div>
  </div>
</div>

            {/* MAP */}
            <div className="relative mt-6 h-[280px] rounded-xl overflow-hidden bg-[#223648]">

              <div className="absolute top-3 left-3 z-[10] bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow">
                📍 Our Global Offices
              </div>

              <button
                className="absolute bottom-14 right-4 z-[10] bg-blue-600 text-white px-3 py-1.5 rounded-lg"
                onClick={() => mapRef.current?.flyTo([17.447764, 78.361649], 17)}
              >
                📍 India
              </button>

              <button
                className="absolute bottom-4 right-4 z-[10] bg-blue-600 text-white px-3 py-1.5 rounded-lg"
                onClick={() => mapRef.current?.flyTo([52.4082, -1.4956], 17)}
              >
                📍 UK
              </button>

        <MapContainer
  ref={mapRef}
  zoomControl={false}
  scrollWheelZoom={false}
  style={{ height: "280px", width: "100%" }}
  className="absolute inset-0 rounded-xl z-0"
>

                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                />

                <FitWorldBounds />

                <Marker position={[17.447764, 78.361649]}>
                  <Popup>India Office – Hyderabad</Popup>
                </Marker>

                <Marker position={[52.4082, -1.4956]}>
                  <Popup>UK Office – Coventry</Popup>
                </Marker>
              </MapContainer>
            </div>
          </div>

          {/* RIGHT FORM */}
         {/* RIGHT FORM */}
<div className="p-10 lg:w-7/12">
  <form onSubmit={handleSubmit} className="space-y-6">

    <input
      name="name"
      value={formData.name}
      onChange={handleChange}
      placeholder="Full Name"
      required
      className="w-full border-b-2 pb-2"
    />

    <input
      name="email"
      value={formData.email}
      onChange={handleChange}
      placeholder="Email"
      required
      className="w-full border-b-2 pb-2"
    />

    <PhoneInput
      country="in"
      value={`${formData.country_code.replace('+', '')}${formData.phoneno}`}
      onChange={(value, country) => {
        setFormData(prev => ({
          ...prev,
          country_code: `+${country.dialCode}`,
          phoneno: value.slice(country.dialCode.length),
        }));
      }}
    />

    {/* ✅ LOCATION */}
    <input
      name="location"
      value={formData.location}
      onChange={handleChange}
      placeholder="Location"
      required
      className="w-full border-b-2 pb-2"
    />

    {/* ✅ PURPOSE */}
    <select
      name="purpose"
      value={formData.purpose}
      onChange={handleChange}
      required
      className="w-full border-b-2 pb-2 bg-transparent"
    >
      <option value="">Select Purpose</option>
      <option value="Business Enquiry">Business Enquiry</option>
      <option value="Partnership">Partnership</option>
      <option value="Support">Support</option>
      <option value="Careers">Careers</option>
      <option value="Other">Other</option>
    </select>

    <textarea
      name="message"
      value={formData.message}
      onChange={handleChange}
      placeholder="Message"
      rows="4"
      required
      className="w-full border-b-2 pb-2"
    />

    <button
      type="submit"
      disabled={isSubmitting}
      className="bg-indigo-900 text-white px-10 py-3 rounded-lg"
    >
      {isSubmitting ? 'Sending...' : 'Submit'}
    </button>

  </form>
  {/* ✅ FORM STATUS MESSAGE AT BOTTOM */}
{/* {formMessage && (
  <div className="max-w-6xl mx-auto mt-12 px-4">
    <div
      className={`text-center p-4 rounded-lg font-semibold mt-12 ${
        messageType === 'success'
          ? 'bg-green-100 text-green-700 border border-green-300'
          : 'bg-red-100 text-red-700 border border-red-300'
      }`}
    >
      {formMessage}
    </div>
  </div>
)} */}

{showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="relative bg-white rounded-lg shadow-xl p-6 w-full max-w-md">

      {/* ❌ Close */}
      <button
        onClick={() => setShowModal(false)}
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
      >
        ✕
      </button>

      <h3
        className={`text-lg font-semibold text-center ${
          modalData.type === "success"
            ? "text-green-600"
            : "text-red-600"
        }`}
      >
        {modalData.type === "success" ? "Success" : "Error"}
      </h3>

      <p className="mt-3 text-center text-gray-700">
        {modalData.message}
      </p>
    </div>
  </div>
)}

</div>

        </div>
        

      </section>

      <Footer />
    </div>
  );
};

export default Contact;
